import { CSSProperties } from '../../../node_modules/@types/react';
import { colors } from '../../styles/colors';

const topBarHeight = 100;
const leftSideWidth = '65%';
const rightSideWidth = '35%';

export const styles = {
    commentSubmitContainer: { height: 40, width: '100%', backgroundColor: 'white', marginTop: -10, position: 'relative' } as React.CSSProperties,
    commentSubmitButton: {
        color: colors.ACTION_GREEN,
        fontSize: 16,
        position: 'absolute',
        right: 15,
        cursor: 'pointer',
        top: 10
    } as React.CSSProperties,
    pointerCursor: {
        cursor: 'pointer'
    },
    dropDownBackground: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        minWidth: 1000,
        zIndex: 500,
    } as CSSProperties,
    bottomPadding: {
        height: 15
    },
    addFamilyMemberButton: {
        fontSize: 16,
        paddingLeft: 20,
        paddingTop: 10,
        fontWeight: 'bold',
        color: colors.ACTION_GREEN
    } as CSSProperties,
    familyMemberName: {
        fontSize: 16,
        paddingLeft: 20,
        paddingTop: 10,
        opacity: 0.85
    },
    familyMemberDropdown: {
        position: 'absolute',
        width: 200,
        maxHeight: 210,
        backgroundColor: '#191513',
        top: 28,
        right: 0,
        zIndex: 1000,
        paddingTop: 10,
        pointerEvents: 'auto',
        overflowX: 'hidden',
        overflowY: 'auto'
    } as CSSProperties,
    container: {
        display: 'flex',
        minWidth: 1000,
        flexDirection: 'column'
    } as CSSProperties,
    topBar: {
        display: 'flex'
    },
    flexOne: {
        display: 'flex',
        flex: 1
    },
    image: {
        width: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        padding: 25,
        alignItems: 'center'
    } as CSSProperties,
    imageContainer: {
        position: 'relative',
        cursor: 'pointer',
        marginRight: 10,
    } as CSSProperties,
    selectedImageContainer: {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: colors.ORANGE,
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1
    } as CSSProperties,
    titleText: {
        fontSize: 26,
        color: 'white',
        fontWeight: 'bolder',
        marginBottom: 10,
        maxWidth: '100%',
        lineHeight: '30px',
        maxHeight: 60,
        wordBreak: 'break-word',
        overflow: 'hidden'
    } as CSSProperties,
    leftSide: {
        width: leftSideWidth,
        backgroundColor: '#47444E',
        position: 'relative',
        height: 'calc(100vh - 100)',
        display: 'flex',
        flexDirection: 'column'
    } as CSSProperties,
    rightSide: {
        width: rightSideWidth,
        backgroundColor: '#464553',
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    } as CSSProperties,
    rightTopBarContainer: {
        width: rightSideWidth,
        backgroundColor: '#545360',
        height: topBarHeight,
        display: 'flex',
        flexDirection: 'row'
    } as CSSProperties,
    leftTopBarContainer: {
        width: leftSideWidth,
        backgroundColor: '#434150',
        height: topBarHeight,
        paddingLeft: 25,
        paddingRight: 25,
        display: 'flex',
        flexDirection: 'row'
    } as CSSProperties,
    photoContainer: {
        width: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    } as CSSProperties,
    commentTypeTabs: {
        backgroundColor: '#363540',
        height: 41,
        width: '100%',
        display: 'flex',
        flexDirection: 'row'
    } as CSSProperties,
    commentInput: {
        backgroundColor: '#54535E',
        // minHeight: 130,
        width: '100%'
        // maxHeight: '70%',
    },
    carouselContainer: {
        padding: 10,
        paddingBottom: 20,
        overflowX: 'scroll',
        display: 'flex',
        flexDirection: 'row',
        position: 'relative',
        overflowY: 'visible'
    } as CSSProperties,
    footerContainer: {
        width: '100%',
    },
    buttonText: {
        fontSize: 16,
        fontWeight: 300
    } as CSSProperties,
    buttonContainer: {
        width: 180,
        height: 50,
        backgroundColor: '#008DA5'
    },
    bottomFooterContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: 15,
        paddingRight: 15
    } as CSSProperties,
    titleContainer: {
        height: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center'
    } as CSSProperties,
    tagContainer: {
        display: 'flex',
        flexDirection: 'row'
    } as CSSProperties,
    rightSideTitle: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        paddingLeft: 30
    } as CSSProperties,
    creatorText: {
        color: 'white',
        fontSize: 18,
        marginRight: 6
    },
    timeText: {
        color: 'white',
        fontSize: 18,
        fontWeight: 'lighter',
        opacity: 0.7
    } as CSSProperties,
    sharedWithText: {
        color: 'white',
        marginRight: 6,
        opacity: 0.7
    },
    familyName: {
        color: 'white',
        position: 'relative',
        cursor: 'pointer'
    } as CSSProperties,
    rightCornerContainer: {
        display: 'flex',
        alignItems: 'flex-end',
        flex: 1,
        padding: 15,
        paddingLeft: 25
    } as CSSProperties,
    storyText: {
        fontSize: 26,
        color: 'white'
    },
    xButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: 25
    } as CSSProperties,
    modalCloseButton: {
        height: 55,
        width: 55,
        objectFit: 'contain',
        cursor: 'pointer'
    } as React.CSSProperties,
    photoButtonsContainer: {
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        bottom: 0,
        top: -(window.innerHeight - 100) * 0.25,
        zIndex: 999,
        left: 0,
        // height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 25
    } as CSSProperties,
    arrowImage: {
        height: 45,
        width: 45,
        opacity: 0.7,
        cursor: 'pointer',
        pointerEvents: 'auto'
    } as React.CSSProperties,
    selectedImage: {
        border: '5px solid ' + colors.ACTION_GREEN
    },
    imageStyle: {
        height: 105,
        width: 'auto',
    } as React.CSSProperties,
    commentTypeContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'relative',
    } as CSSProperties,
    commentTabText: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        color: colors.HALF_WHITE
    } as React.CSSProperties,
    commentTabTextActive: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        color: colors.ACTION_GREEN
    } as React.CSSProperties,
    selectedBar: {
        width: '100%',
        height: 5,
        backgroundColor: colors.ACTION_GREEN,
        position: 'absolute',
        bottom: 0,
    } as React.CSSProperties,
    inputContainer: {
        display: 'flex',
        flex: 1,
        backgroundColor: 'white',
        paddingTop: 8,
        paddingRight: 50,
        maxHeight: 300,
        resize: 'none',
        autoResize: true
    },
    sideButtonContainer: {
        position: 'relative',
        top: 7.5,
        right: -35,
        height: 50,
        width: 100,
        backgroundColor: '#00A59B',
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    } as CSSProperties,
    sideButtonText: {
        color: 'white',
        fontSize: 18
    },
    inputPadding: {
        // padding: 25,
    },
    fullContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1
    } as CSSProperties,
    storyTag: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 4,
        paddingBottom: 3,
        backgroundColor: '#DF957F',
        borderRadius: 5,
        marginRight: 8
    },
    tagText: {
        color: 'white'
    },
    authorMargin: {
        marginBottom: 7
    }
};



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/PhotoViewerStyles.ts